import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'search-graph-dashboard.dashboard-label',
		defaultMessage: 'Dashboard',
		description: 'Dashboard subtype label',
	},
});
